import React from 'react';
import { Checkbox, Tooltip } from '@material-ui/core';
import { useActions, useValues } from 'kea';
import alertlogic from 'src/store/alert';

const EnableButton = ({ row, index }) => {

	const { update, loading } = useActions(alertlogic);

	const handle_edit = (e) => {
		let changed_alert = row;
		changed_alert.vehicles[index].enabled = e.target.checked;
		update(changed_alert);
	}

	return (
		<>
			<Tooltip title='Enable/Disable this assignment'>
				<Checkbox
					disabled={loading}
					checked={row.vehicles[index].enabled}
					color="primary"
					onChange={(e) => handle_edit(e)}
					inputProps={{ 'aria-label': 'primary checkbox' }}
				/>
			</Tooltip>
		</>
	);
};

export default EnableButton;
